export default {
  namespaced: true,
  state: {
    isMobile: false,
    theme: 'dark',
    layout: 'side',
    // footerLinks: [
    //   {link: 'https://pro.ant.design', name: 'Pro首页'},
    //   {link: 'https://github.com/iczer/vue-antd-admin', icon: 'github'},
    //   {link: 'https://ant.design', name: 'Ant Design'}
    // ],
    multipage: false,
    pageList: [],
    systemName: '渠道分销管理系统',
    en: sessionStorage.getItem('en') || 'zh',
  },
  mutations: {
    setDevice(state: { isMobile: any }, isMobile: any) {
      state.isMobile = isMobile
    },
    changelan(state: any, changelan: any) {
      sessionStorage.setItem('en', changelan)
      state.en = changelan
    },
    setTheme(state: { theme: any }, theme: any) {
      state.theme = theme
    },
    setLayout(state: { layout: any }, layout: any) {
      state.layout = layout
    },
    setMultipage(state: { multipage: any }, multipage: any) {
      state.multipage = multipage
    },
  },
}
